// MenuContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const MenuContext = createContext();

export const useMenuData = () => useContext(MenuContext);

export const MenuProvider = ({ children }) => {
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const response = await fetch(
          "https://lifetimedesign.in/LtcJsonAPI.asmx/GetMenuDesigns",
        );
        const result = await response.json();
        const menuArray = result.data || result.d || result;
        const transformedMenu = (menuArray || [])
          .map((category) => ({
            id: category.id,
            title: category.name,
            count: category.count || 0,
            columns: (category.subcategories || []).map((subcat) => ({
              id: subcat.id,
              heading: subcat.name,
              count: subcat.count || 0,
              links: (subcat.innercategories || []).map((inner) => ({
                id: inner.id,
                label: inner.name,
                count: inner.count || 0,
              })),
            })),
          }))
          .filter((item) => item.columns.length > 0);
        setMenuData(transformedMenu);
      } catch (error) {
        console.error("Menu fetch error:", error);
      }
    };

    fetchMenuData();
  }, []);

  return (
    <MenuContext.Provider value={{ menuData }}>{children}</MenuContext.Provider>
  );
};
